// src/Services/fetchPasswordHistory.js
import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchPasswordHistory = async (username) => {
  const method = "GET";

  // extrae el token del localStorage
  const loginData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token     = loginData?.data?.token;
  const headers   = token ? { Authorization: `Bearer ${token}` } : {};

  // monta la ruta sustituyendo {username}
  const path = USERS.history.replace(
    "{username}",
    encodeURIComponent(username)
  );

  // llama al interceptor
  const response = await ApiRequestInterceptor(path, method, null, headers);

  if (response.code === 200) {
    // el backend devuelve { username, history: [...] }
    return response.data.history;
  } else if (response.code === 401) {
    throw new Error("No autorizado");
  } else if (response.code === 403) {
    throw new Error("Acceso denegado");
  } else if (response.code === 404) {
    throw new Error("Usuario no encontrado");
  } else {
    throw new Error(
      response.data?.error || "Error al obtener el historial de contraseñas"
    );
  }
};
